import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteTagGroup = {
  name: "deleteTagGroup" as const,
  input: z.object({ tagGroupId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
